import { Table } from "antd";
import { useEffect, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { getColumnSearchProps } from "../../../utils/tables";
import { selectUser } from "../../../redux/slices/user";

const OrderGluing = ({
  queuedOrders,
  getQueuedOrders,
  loadingTable,
  filtersRef,
  currentPage = 1,
  pageSize = 10,
  tableFilters = {},
  onTableChange,
  onSearchApply,
}) => {
  const user = useSelector(selectUser);
  const isAdmin = user.admin;
  const isFirstRender = useRef(true);
  const searchInput = useRef(null);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    getQueuedOrdersHandler();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, tableFilters]);

  useEffect(() => {
    const countup = setInterval(() => {
      getQueuedOrdersHandler();
    }, 30000);
    return () => clearInterval(countup);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, tableFilters]);

  const getQueuedOrdersHandler = () => {
    getQueuedOrders({
      user: user.id,
      isAdmin,
      current: currentPage,
      pageSize: pageSize,
      filters: tableFilters,
    });
  };

  const columns = useMemo(
    () => [
      {
        title: "Ticket",
        dataIndex: "ticket",
        key: "ticket",
        filteredValue: tableFilters?.ticket ? [tableFilters.ticket] : null,
        ...getColumnSearchProps(
          "ticket",
          searchInput,
          filtersRef,
          false,
          onSearchApply
        ),
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        filteredValue: tableFilters?.cliente ? [tableFilters.cliente] : null,
        ...getColumnSearchProps(
          "cliente",
          searchInput,
          filtersRef,
          false,
          onSearchApply
        ),
      },
      {
        title: "Teléfono",
        dataIndex: "telefono",
        key: "telefono",
        filteredValue: tableFilters?.telefono ? [tableFilters.telefono] : null,
        ...getColumnSearchProps(
          "telefono",
          searchInput,
          filtersRef,
          false,
          onSearchApply
        ),
      },
      {
        title: "Sucursal",
        dataIndex: "sucursal",
        key: "sucursal",
        filteredValue: tableFilters?.sucursal ? [tableFilters.sucursal] : null,
        ...getColumnSearchProps(
          "sucursal",
          searchInput,
          filtersRef,
          false,
          onSearchApply
        ),
      },
      {
        title: "Tipo de Orden",
        dataIndex: "tipo_orden",
        key: "tipo_orden",
        filters: [
          { value: "takeout", text: "PARA LLEVAR" },
          { value: "delivery", text: "DOMICILIO" },
        ],
        filteredValue: tableFilters?.tipo_orden
          ? [tableFilters.tipo_orden]
          : null,
        filterMultiple: false,
        render: (value) => value,
      },
      {
        title: "Driver",
        dataIndex: "tiempo_driver_llegar",
        key: "tiempo_driver_llegar",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
      },
      {
        title: "Tiempo total",
        dataIndex: "tiempo_transcurrido",
        key: "tiempo_transcurrido",
        align: "center",
      },
      {
        title: "Tiempo aprox. de recogida",
        dataIndex: "tiempo_aprox_recogida",
        key: "tiempo_aprox_recogida",
        align: "center",
        render: (text) => <strong style={{ color: "#9E3223" }}>{text}</strong>,
      },
    ],
    [tableFilters, filtersRef, onSearchApply]
  );

  return (
    <Table
      loading={loadingTable}
      columns={columns}
      dataSource={queuedOrders?.orders || []}
      rowKey={(record, i) => record?.id ?? record?.ticket ?? i}
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: queuedOrders?.total,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      }}
      onChange={onTableChange}
    />
  );
};

export default OrderGluing;
